import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { fetchGifs, fetchGifsSuccess, fetchGifsFailure } from '../actions/extension-gif';
export default handleActions({
    [`${fetchGifs}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            fetching: true,
            search: action.payload.q,
            page: action.payload.pg
        }),
    [`${fetchGifsSuccess}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            fetching: false,
            items: state.search.length > 0 && state.page > 0 ? state.items.concat(action.payload.gifs) : action.payload.gifs,
            hasMore: state.search && (action.payload.gifs || []).length,
            page: state.page + 1,
            apiError: false
        }),
    [`${fetchGifsFailure}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            fetching: false,
            apiError: true,
            hasMore: false
        })
}, {
    search: '',
    items: [],
    page: 0,
    fetching: false,
    hasMore: false,
    apiError: false
});

//# sourceMappingURL=extension-gif.js.map